import { Component } from '@angular/core';
@Component({
  selector: 'app-page-loader',
  template: `<ngx-loading-bar color="#3173D6"></ngx-loading-bar>`
})
export class PageLoaderComponent { }
